<template>
<div>
<div v-if="promocoes.length > 0" id="slider">
  <carousel-3d :autoplay="true" :autoplay-timeout="5000" :perspective="0" :space="500" :display="3" :width="600" :height="430" :border="0">
    <slide v-for="(promocao, i) in promocoes" :index="i" :key="promocao.id">
        <div class="slider-div">
          <div class="outer-div" @click="comprar(promocao)">
            <div :style="{'background': 'url(' + promocao.ProdutoUrlImagens + ')', 'background-size': 'cover'}" class="inner-div"></div>
          </div>
        <div class="expira">
          <div><i class="far fa-hourglass icone-ampulheta"></i></div>
          <div class="expira-hora">
          <countdown @end="finalCountdown(promocao.ProdutoId)" :time="dataContador(promocao.DataFim)">
            <template slot-scope="props">
              <div v-if="props.days == 0">
              expira em {{ props.days > 0 ? props.days + 'd' : '' }} {{ props.hours > 0 ? props.hours + 'h' : '' }} {{ props.minutes }}m {{ props.seconds }}s
              </div>
              <div v-else>
              expira em {{new Date(promocao.DataFim.toDate()).toISOString() | moment("DD/MM")}} às {{promocao.HorarioFim.replace(':', 'h')}}
              </div>
            </template>
          </countdown>
          </div>
        </div>
        <div class="div-texto-container"></div>
        <div class="div-texto">
          <h2 class="titulo">{{promocao.ProdutoTitulo.toUpperCase()}}</h2>
          <span class="descricao">
            <span v-if="promocao.SemData == false">
              <i class="far fa-calendar-alt icone-calendario"></i>
              {{new Date(promocao.DataOk.toDate().toISOString()) | moment("ddd, DD/MM")}}
            </span>
            <i class="far fa-clock icone-relogio"></i>
            {{promocao.Horario}} | {{promocao.Turno}}</span>
          <p class="preco">de <span class="preco-cardapio">{{promocao.ProdutoPrecoCardapio | numeroPreco}}</span> por {{promocao.PrecoPromocional | numeroPreco}}</p>
          <button class="btn" @click="comprar(promocao)">COMPRAR</button>
        </div>
      </div>
    </slide>
  </carousel-3d>
</div>
</div>
</template>

<script>
import { db, Timestamp } from '@/firebase.js'
import { Carousel3d, Slide } from 'vue-carousel-3d'
import VueScreenSize from 'vue-screen-size'
import _ from 'lodash'
export default {
  name: 'SliderPrincipal',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  data: function () {
    return {
      slides: 3,
      promocoes: [],
      valorQuantidade: 0
    }
  },
  components: {
    Carousel3d,
    Slide,
    db
  },
  created () {
    this.getPromocoes()
  },
  methods: {
    dataContador (promocaoDataFim) {
      return Math.trunc((promocaoDataFim.toDate()) - Date.now())
    },
    finalCountdown (produtoId) {
      this.promocoes = this.promocoes.filter((obj) => {
        return obj.ProdutoId !== produtoId
      })
    },
    getPromocoes () {
      let loader = this.$loading.show({
        container: null,
        fullPage: true,
        color: '#F85E28',
        loader: 'spinner',
        width: 100,
        height: 100,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      })
      db.collection('Promocoes').where('Ativo', '==', true).where('Destaque', '==', true).limit(10).onSnapshot((querySnapshot) => {
        querySnapshot.docChanges().forEach((change) => {
          if (change.type === 'added') {
            if (change.doc.data().DataInicio < Timestamp.now()) {
              if (change.doc.data().DataFim > Timestamp.now()) {
                this.valorQuantidade = 0
                Object.keys(change.doc.data().QtdUnidades).forEach((key) => {
                  this.valorQuantidade = (this.valorQuantidade + change.doc.data().QtdUnidades[key]) - change.doc.data().QtdUnidadesReserva[key]
                })
                if (this.valorQuantidade > 0) {
                  var documento = change.doc.data()
                  documento.id = change.doc.id
                  this.promocoes.push(documento)
                  this.promocoes = _.sortBy(this.promocoes, o => [o.DataOk, o.Horario, o.ProdutoTitulo])
                }
              }
            }
          } else if (change.type === 'modified') {
            this.promocoes = this.promocoes.filter((obj) => {
              return obj.id !== change.doc.id
            })
            if (change.doc.data().DataInicio < Timestamp.now()) {
              if (change.doc.data().DataFim > Timestamp.now()) {
                this.valorQuantidade = 0
                Object.keys(change.doc.data().QtdUnidades).forEach((key) => {
                  this.valorQuantidade = (this.valorQuantidade + change.doc.data().QtdUnidades[key]) - change.doc.data().QtdUnidadesReserva[key]
                })
                if (this.valorQuantidade > 0) {
                  var documento2 = change.doc.data()
                  documento2.id = change.doc.id
                  this.promocoes.push(documento2)
                  this.promocoes = _.sortBy(this.promocoes, o => [o.DataOk, o.Horario, o.ProdutoTitulo])
                }
              }
            }
          } else if (change.type === 'removed') {
            this.promocoes = this.promocoes.filter((obj) => {
              return obj.id !== change.doc.id
            })
          }
        })
      })
      loader.hide()
    },
    comprar (documento) {
      localStorage.setItem('promoProps', JSON.stringify(documento))
      this.$router.push({name: 'Comprar', params: {id: documento.id}})
    }
  }
}
</script>

<style scoped>
.expira {
  position: absolute;
  z-index: 50;
  top: 30px;
  left: 35px;
  display: flex;
  color: #FFF;
  align-items: center;
}
.expira-hora {
  margin: 0 0 0 8px;
  font-weight: 500;
  font-size: 0.8rem;
}
.icone-ampulheta {
  width: 13px;
  height: 13px;
  align-self: center;
}
.icone-relogio {
  margin: 0 0 0 10px;
}
#slider {
  margin-top: 60px;
}
.carousel-3d-container figure {
  margin:0;
}
.carousel-3d-container figcaption {
  position: absolute;
  color: #fff;
  bottom: 0;
  position: absolute;
  bottom: 0;
  padding: 15px;
  font-size: 12px;
  min-width: 100%;
  box-sizing: border-box;
  background: coral;
}
.outer-div {
  width: 600px;
  height: 400px;
  overflow: hidden;
  margin: 0 0 12px 0;
  border: 20px solid #fff;
  cursor: pointer;
}
.inner-div {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
}
.slider-div {
  background: #fff;
  text-align: center;
  position: relative;
}
.div-texto-container {
  background: #000;
  opacity: 0.3;
  position: absolute;
  top: 250px;
  width: 560px;
  height: 100px;
  z-index: 50;
  margin: 0 20px;
}
.div-texto {
  opacity: 1.0;
  z-index: 60;
  position: absolute;
  margin: 0 auto;
  width: 600px;;
  text-align: center;
}
.titulo, .descricao, .preco {
  color: #fff;
}
.titulo {
  margin: -155px auto 0 auto;
  font-size: 1.8em;
  font-weight: 800;
}
.descricao, .preco {
  font-size: 1.2em;
  font-weight: 600;
}
.btn {
  margin: 30px auto;
}
@media (max-width: 1170px) {
  #slider {
      transform: scale(0.8);
  }
}
@media (max-width: 760px) {
  #slider {
      display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SliderPrincipal.vue